export default __webpack_public_path__ + "static/media/G_EVOLUTION_CARACTERISTICAS_ILUSTRACION.96bfe630.png";